<div class="tableComponent">
  <cdk-virtual-scroll-viewport coreTableVirtualScroll [rowHeight]="rowHeight" [offset]="hideHeader ? 0 : offset">
    <mat-table tableSort matSort [dataSource]="dataSource" [trackBy]="trackBy">
      <ng-container *ngFor="let column of columns" matColumnDef="{{ column.name }}">
        <mat-header-cell
          *matHeaderCellDef="let element"
          [ngClass]="getColumnCssClass(column.header, element)"
          [mat-sort-header]="column.table.displayValue"
        >
          <table-header [element]="element" [header]="column.header"> </table-header>
        </mat-header-cell>

        <mat-cell *matCellDef="let element" [ngClass]="getColumnCssClass(column.table, element)">
          <table-column [element]="element" [table]="column.table"> </table-column>
        </mat-cell>
      </ng-container>

      <ng-container *ngIf="!hideHeader">
        <mat-header-row *matHeaderRowDef="this.header" [style.top.px]="headerOffset | async"></mat-header-row>
      </ng-container>
      <mat-row
        *matRowDef="let row; columns: this.header; let rowContainer"
        (click)="rowHasClickHandler ? tableDefinition.tableRow.click(rowContainer) : noop()"
        [ngClass]="updateClasses(rowContainer)"
        [matTooltip]="row?.toolTip"
        [matTooltipShowDelay]="750"
      >
      </mat-row>
    </mat-table>
    <div
      class="not-found"
      *ngIf="!dataSource || !dataSource.data || dataSource.data.length === 0"
      [translate]="'leitstand.log.notFound'"
    >
    </div>
  </cdk-virtual-scroll-viewport>
</div>
